'use client';

import {
  BarChart3,
  Building2,
  CalendarClock,
  ClipboardCheck,
  CreditCard,
  FlaskConical,
  GraduationCap,
  Handshake,
  Headset,
  Ellipsis,
  LayoutDashboard,
  LineChart,
  Link2,
  Plug,
  PieChart,
  Lock,
  Megaphone,
  MessageSquare,
  Settings,
  Shield,
  ShoppingBag,
  ThumbsUp,
  Trophy,
  User,
  Users,
  type LucideIcon,
} from 'lucide-react';
import { cn } from '@/lib/utils';

const NAV_ICON_MAP: Record<string, LucideIcon> = {
  dashboard: LayoutDashboard,
  academy: GraduationCap,
  more: Ellipsis,
  messages: MessageSquare,
  customers: Users,
  simulation: FlaskConical,
  evaluate: ClipboardCheck,
  intelligence: PieChart,
  votes: ThumbsUp,
  settings: Settings,
  link: Link2,
  integrations: Plug,
  usage: BarChart3,
  schedule: CalendarClock,
  billing: CreditCard,
  achievements: Trophy,
  store: ShoppingBag,
  partners: Handshake,
  tickets: Headset,
  admin: Shield,
  outreach: Megaphone,
  marketingOs: LineChart,
  orgManagement: Building2,
  profile: User,
  security: Lock,
};

type NavItemIconProps = {
  icon?: string;
  className?: string;
};

export function NavItemIcon({ icon, className }: NavItemIconProps) {
  if (!icon) return null;
  const Icon = NAV_ICON_MAP[icon];
  if (!Icon) return null;
  return <Icon className={cn('h-4 w-4 shrink-0 opacity-80', className)} aria-hidden />;
}
